<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Dane konta
          </v-card-title>
          <v-card-text>
            <UserAccount></UserAccount>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import UserAccount from '../components/UserAccount';
export default {
  components: {UserAccount}
}
</script>